// plugins/lenis.js
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default defineNuxtPlugin(nuxtApp => {
  if (!import.meta.client) return; // Solo client side

  gsap.registerPlugin(ScrollTrigger);

  class SmoothScroll {
    core;
    lastDirection = null;
    rafCallback = null;

    constructor(options = {}) {
      this.core = new Lenis({
        // duration: options.duration || 1.2,
        overscroll: false,
      });

      this.core.on('scroll', () => {
        ScrollTrigger.update();
        this.#detectDirection();
      });

      gsap.ticker.lagSmoothing(0);

      // Store callback reference for proper cleanup
      this.rafCallback = time => {
        this.core.raf(time * 1000);
      };
      gsap.ticker.add(this.rafCallback);

      ScrollTrigger.defaults({
        // markers: process.env.NODE_ENV === 'development',
      });
    }

    #detectDirection() {
      let dir = this.core.direction;
      if (dir === 1) {
        this.core.rootElement.classList.add('lenis-down');
      } else if (dir === -1) {
        this.core.rootElement.classList.add('lenis-up');
      }
      this.lastDirection = dir;
    }

    init() {
      this.core.start();
    }

    start() {
      this.core.start();
      this.core.resize();
    }

    stop() {
      this.core.stop();
    }

    destroy() {
      this.core.destroy();
      if (this.rafCallback) {
        gsap.ticker.remove(this.rafCallback);
        this.rafCallback = null;
      }
      if (this.core.rootElement) {
        this.core.rootElement.classList.remove('lenis-up', 'lenis-down');
      }
    }

    refresh() {
      ScrollTrigger.refresh();
    }

    resize() {
      this.core.resize();
    }

    scrollTo(target, options) {
      this.core.scrollTo(target, options);
    }
  }

  const smoothScroll = new SmoothScroll();
  smoothScroll.init();
  nuxtApp.provide('Lenis', smoothScroll);
});
